import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid
} from "@mui/material";
import { useEffect, useState } from "react";
import { postCorregirFichaje } from "../../services/apis";

export default function DialogCorregirFichaje({
    open,
    onClose,
    fichaje,
    fichajesUsuario,
    usuarioId
}) {
    const [data, setData] = useState({
        hora_inicio: "",
        hora_fin: "",
        observacion: "",
        id_usuario: usuarioId
    });

    // datetime-local requiere formato sin segundos
    const toInputValue = (dateString) => {
        if (!dateString) return "";
        return dateString.replace(" ", "T").slice(0, 16);
    };

    // Normalizar a formato MySQL: YYYY-MM-DD HH:mm:ss
    const normalize = (dt) => {
        if (!dt) return "";

        let final = dt.replace("T", " ");

        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(final)) {
            return final;
        }

        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(final)) {
            return final + ":00";
        }

        return final;
    };

    useEffect(() => {
        if (fichaje) {
            setData({
                hora_inicio: toInputValue(fichaje.hora_inicio),
                hora_fin: toInputValue(fichaje.hora_fin),
                observacion: fichaje.observacion || "",
                id_usuario: usuarioId
            });
        }
    }, [fichaje, usuarioId]);

    const handleChange = (e) => {
        setData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const save = async (data) => {
        try {
            const response = await postCorregirFichaje(data);

            if (response.success) {
                fichajesUsuario(usuarioId);
                onClose();
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const handleSave = () => {
        const fichajeCorregido = {
            ...fichaje,
            hora_inicio: normalize(data.hora_inicio),
            hora_fin: normalize(data.hora_fin),
            observacion: data.observacion,
            id_usuario: usuarioId
        };

        save(fichajeCorregido);
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>
                Corregir fichaje #{fichaje?.id_fichaje}
            </DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            label="Fecha y hora inicio"
                            type="datetime-local"
                            fullWidth
                            name="hora_inicio"
                            value={data.hora_inicio}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Fecha y hora fin"
                            type="datetime-local"
                            fullWidth
                            name="hora_fin"
                            value={data.hora_fin}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Observación"
                            fullWidth
                            name="observacion"
                            value={data.observacion}
                            onChange={handleChange}
                            multiline
                            rows={3}
                        />
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button
                    onClick={handleSave}
                    variant="contained"
                    color="primary"
                    disabled={!data.hora_inicio || !data.hora_fin}
                >
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
